/**
 * Logs only in development. Use instead of console.log in hot paths so production
 * stays fast and DevTools stays quiet.
 */
export function devLog(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.log(...args)
  }
}
